import { useSensorPage } from '@apis/rendall/queries/use-sensor-page';
import { MINUTE_IN_MS } from 'ae-constants/constants';

import type { Option } from '../use-option-cache/use-option-cache';

export const useSensorOptions = () => {
  const { data: sensorData } = useSensorPage({
    staleTime: 5 * MINUTE_IN_MS,
    select: (sensorPage) =>
      sensorPage.items
        .filter(({ name, deploymentID }) => name && deploymentID)
        .map<Option>(({ name, deploymentID }) => ({
          value: deploymentID,
          label: name,
        })),
  });

  return sensorData ?? [];
};
